<!-- @format -->

<template>
  <a-form :form="form" :labelCol="{ span: 10 }" :wrapperCol="{ span: 12 }" @submit="handleSubmit">
    <a-row>
      <a-col :span="6">
        <a-form-item label="车场名称">
          <a-input :disabled="true" defaultValue="parkingName" />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item label="月卡套餐">
          <a-select>
            <a-select-option value="1">
              地面
            </a-select-option>
            <a-select-option value="2">
              地下
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item label="车位信息">
          <a-input :disabled="true" defaultValue="车位信息" />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item label="授权区域">
          <a-input :disabled="true" defaultValue="授权区域" />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item label="是否固定车位">
          <a-input :disabled="true" defaultValue="是否固定车位" />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item label="卡类型">
          <a-input :disabled="true" defaultValue="卡类型" />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item label="授权周期">
          <a-input :disabled="true" defaultValue="授权周期" />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item label="套餐单价">
          <a-input :disabled="true" defaultValue="套餐单价" />
        </a-form-item>
      </a-col>
    </a-row>
    <div
      v-for="(k, index) in form.getFieldValue('keys')"
      :key="k"
      v-bind="index === 0 ? formItemLayout : formItemLayoutWithOutLabel"
    >
      <a-row>
        <a-col :span="6">
          <a-form-item label="车牌号">
            <a-input />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="车型">
            <a-input />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="备注">
            <a-input />
          </a-form-item>
        </a-col>
        <a-col :offset="1" :span="2">
          <a-icon
            v-if="form.getFieldValue('keys').length > 1"
            class="dynamic-delete-button"
            type="minus-circle-o"
            :disabled="form.getFieldValue('keys').length === 1"
            @click="() => remove(k)"
          />
        </a-col>
      </a-row>
    </div>
    <div style="margin-left:40px;">
      <a-button @click="add"> <a-icon type="plus" /> Add field </a-button>
    </div>
  </a-form>
</template>

<script>
/** @format */

let id = 0;
export default {
  data() {
    return {
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 }
        }
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 }
        }
      }
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'dynamic_form_item' });
    this.form.getFieldDecorator('keys', { initialValue: [], preserve: true });
  },
  methods: {
    remove(k) {
      const { form } = this;
      // can use data-binding to get
      const keys = form.getFieldValue('keys');
      // We need at least one passenger
      if (keys.length === 1) {
        return;
      }

      // can use data-binding to set
      form.setFieldsValue({
        keys: keys.filter(key => key !== k)
      });
    },

    add() {
      const { form } = this;
      // can use data-binding to get
      const keys = form.getFieldValue('keys');
      const nextKeys = keys.concat(id++);
      // can use data-binding to set
      // important! notify form to detect changes
      form.setFieldsValue({
        keys: nextKeys
      });
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          const { keys, names } = values;
          console.log('Received values of form: ', values);
          console.log('Merged values:', keys.map(key => names[key]));
        }
      });
    }
  }
};
</script>
<style>
/** @format */

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.dynamic-delete-button:hover {
  color: #777;
}
.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
